{
  "de": {
    "pagination": {
      "previous": "Vorherige Seite",
      "next": "Nächste Seite",
      "page_report": "Seite {page} von {total}",
      "report": "Zeigt {first} bis {last} von {total}",
      "total": "Gesamtzahl der Einträge: {total}"
    }
  }
}
